import type { BaseDocument } from './types'
import useLoginStore from '@/store/LoginStore'

/**
 * Generate audit fields for creating a new entity
 */
export const createAuditFields = (userId: string) => ({
  createdOn: Date.now(),
  createdBy: userId,
  updatedOn: Date.now(),
  updatedBy: userId,
  deletedOn: null,
  deletedBy: null,
})

/**
 * Generate audit fields for updating an entity
 */
export const updateAuditFields = (userId: string) => ({
  updatedOn: Date.now(),
  updatedBy: userId,
})

/**
 * Generate soft delete fields
 */
export const deleteAuditFields = (userId: string) => ({
  isDeleted: true,
  deletedOn: Date.now(),
  deletedBy: userId,
  updatedOn: Date.now(),
  updatedBy: userId,
})

/**
 * Get environment context
 * Note: envId maps to workspaceId from LoginStore
 */
export const getContext = () => ({
  envId: useLoginStore.getState().workspaceId,
})

/**
 * Create a complete entity with all required base fields
 */
export const createEntity = <T extends Partial<BaseDocument>>(
  data: T,
  userId: string
): T & BaseDocument => ({
  id: crypto.randomUUID(),
  ...getContext(),
  isDeleted: false,
  ...createAuditFields(userId),
  ...data,
} as T & BaseDocument)
